import {VStack} from '@chakra-ui/layout';
import {HStack} from '@chakra-ui/react';
import React from 'react';

import {Text} from '../../../index';
import type {AvatarOptionNew} from '../schema';

import {SelectAvatar} from './SelectAvatar';

export const formatOptionLabel = (data: AvatarOptionNew) => {
  const {label} = data;
  const avatar = (`avatar` in data && data.avatar) || (
    <SelectAvatar name={label.trim()} src={data.avatar_url} variant={data.variant} />
  );

  return (
    <HStack>
      {avatar}
      <VStack alignItems={`stretch`} flex={1} gap={0}>
        <Text size={`md`}>{label}</Text>
        {data.primary_email && (
          <Text size={`sm`} color={`text.muted`}>
            {data.primary_email}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};
